<header class="site-header">
  <div class="header-shell">
    <a class="logo-link" (click)="scrollToTop()" aria-label="Go to top">
      <img src="images/mobilizers/orderyaa-erp.png" alt="orderYaa ERP" class="logo-img" />
    </a>

    <div class="nav-actions-group">
      <nav class="main-nav" aria-label="Primary">
        <a
          class="nav-link"
          [class.nav-link-active]="activeHomeSection === 'core-modules'"
          routerLink="/"
          fragment="core-modules"
          (click)="setActiveHomeSection('core-modules')"
        >Core modules</a>
        <a
          class="nav-link"
          [class.nav-link-active]="activeHomeSection === 'applications'"
          routerLink="/"
          fragment="applications"
          (click)="setActiveHomeSection('applications')"
        >Applications</a>
        <a class="nav-link" routerLink="/business" routerLinkActive="nav-link-active">Business</a>
        <a class="nav-link" routerLink="/pricing" routerLinkActive="nav-link-active">Pricing</a>
        <a class="nav-link" routerLink="/help" routerLinkActive="nav-link-active">Help</a>
      </nav>

      <div class="header-actions">
        <a class="sign-in-link" [href]="erpBaseUrl" target="_blank">Sign in</a>
        <button class="try-button" type="button" (click)="goToProduct()">Try it free</button>

        <button
          class="hamburger-btn"
          type="button"
          aria-label="Toggle navigation menu"
          [attr.aria-expanded]="showMobileMenu"
          [class.hamburger-btn-open]="showMobileMenu"
          (click)="toggleMobileMenu()"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
  </div>

  <nav class="mobile-nav" *ngIf="showMobileMenu" aria-label="Mobile primary">
    <a class="mobile-nav-link" routerLink="/" fragment="core-modules" (click)="closeMobileMenu()">Core modules</a>
    <a class="mobile-nav-link" routerLink="/" fragment="applications" (click)="closeMobileMenu()">Applications</a>
    <a class="mobile-nav-link" routerLink="/business" (click)="closeMobileMenu()">Business</a>
    <a class="mobile-nav-link" routerLink="/pricing" (click)="closeMobileMenu()">Pricing</a>
    <a class="mobile-nav-link" routerLink="/help" (click)="closeMobileMenu()">Help</a>
  </nav>
</header>
